<script>
  export let data;
  export let how_many_first_columns_left_align = 0;

  function tausender_trenner(number) {
    if (typeof number == "string") {
      return number;
    }

    // Info: Die '' sind zwei Hochkommas
    number = "" + number;
    if (number.length > 3) {
      var mod = number.length % 3;
      var output = mod > 0 ? number.substring(0, mod) : "";
      var i = 0;
      for (i = 0; i < Math.floor(number.length / 3); i++) {
        if (mod == 0 && i == 0) output += number.substring(mod + 3 * i, mod + 3 * i + 3);
        // hier wird das Trennzeichen festgelegt mit '.'
        else output += "." + number.substring(mod + 3 * i, mod + 3 * i + 3);
      }
      return output;
    } else return number;
  }
</script>

<table style="width:100%">
  <tr style="margin-left: 20px; margin-right: 20px;">
    {#each data["columns"] as { value, border_col_top, border_col_sides, background_color, extra_class, text_color }}
      <th
        style="
        text-align:center;
	{extra_class ? extra_class + ';' : ''}
	{background_color ? 'background-color: ' + background_color + ';' : ''}
	{text_color ? 'color: ' + text_color + ';' : ''}
	{border_col_top ? 'border-top: solid 1px ' + border_col_top + ';' : ''}
	{border_col_sides ? 'border-left: solid 1px ' + border_col_sides + ';' : ''}
	{border_col_sides ? 'border-right: solid 1px ' + border_col_sides + ';' : ''}
	"
      >
        {#if value != 0 && value != "0"}
          {@html value}
        {/if}
      </th>
    {/each}
  </tr>

  {#each data["values"] as value_row}
    <tr style="margin-left: 20px; margin-right: 20px; ">
      {#each value_row as { value, border_col_top, border_col_sides, background_color, extra_class, text_color, border_bottom, font_weight, text_align, colspan }, index}
        <td
          {colspan}
          style="

          {!text_align && index < how_many_first_columns_left_align ? 'text-align:left;' : 'text-align:right;'} 
		{extra_class ? extra_class + ';' : ''}
		{background_color ? 'background-color: ' + background_color + ';' : ''}
		{text_color ? 'color: ' + text_color + ';' : ''}
		{border_col_sides ? 'border-left: solid 1px ' + border_col_sides + ';' : ''}
		{border_col_sides ? 'border-right: solid 1px ' + border_col_sides + ';' : ''}
		{border_col_top ? 'border-top: solid 1px ' + border_col_top + '; ' : ''}
		{border_bottom ? 'border-bottom: solid 1px ' + border_bottom + ';' : ''}
		{font_weight ? 'font-weight:' + font_weight.toString() + ';' : ''}
		{text_align ? 'text-align:' + text_align + ';' : ''}
		
		"
        >
          {#if value != 0 && value != "0"}
            {@html tausender_trenner(value)}
          {/if}
        </td>
      {/each}
    </tr>
  {/each}
</table>

<!-- <div class="row" style="margin-left: 20px; margin-right: 20px;">
	
{#each data['columns'] as {value, border_col_top, border_col_sides, background_color, extra_class, text_color}}
<div class="col {(extra_class) ? extra_class : ''}" 
	style="
	{(background_color) ? 'background-color: ' + background_color + ';' : ''}
	{(text_color) ? 'color: ' + text_color + ';' : ''}
	{(border_col_top) ? 'border-top: solid 1px ' + border_col_top + ';' : ''}
	{(border_col_sides) ? 'border-left: solid 1px ' + border_col_sides + ';' : ''}
	{(border_col_sides) ? 'border-right: solid 1px ' + border_col_sides + ';' : ''}
	">
	{value}
</div>
{/each}
</div>

{#each data['values'] as value_row}
	<div class="row" style="margin-left: 20px; margin-right: 20px;">
		{#each value_row as {value, border_col_top, border_col_sides, background_color, extra_class, text_color, border_bottom}}

		<div class="col {(extra_class) ? extra_class : ''}" 
		style="
		{(background_color) ? 'background-color: ' + background_color + ';' : ''}
		{(text_color) ? 'color: ' + text_color + ';' : ''}
		{(border_col_sides) ? 'border-left: solid 1px ' + border_col_sides + ';' : ''}
		{(border_col_sides) ? 'border-right: solid 1px ' + border_col_sides + ';' : ''}
		{(border_col_top) ? 'border-top: solid 1px ' + border_col_top + '; ' : ''}
		{(border_bottom) ? 'border-bottom: solid 1px ' + border_bottom + ';' : ''}
		">
			{value}
		</div>
		{/each}
	
	</div>

{/each }
 -->
